import { useMediaQuery, useTheme } from "@mui/material";

export function useIsXs(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("xs"));
}
